import React from 'react';
import PropTypes from 'prop-types'
import { Alert, Glyphicon, Form, FormGroup, Col, ControlLabel, FormControl, ToggleButton, ToggleButtonGroup, ButtonToolbar } from 'react-bootstrap/lib';
import Button from 'react-bootstrap-button-loader';

/**
 * It allows to do log in the application
 * It asks for username, password and site
 */
class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.onSignInClicked = this.onSignInClicked.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);   
    this.state = {
      error: null
    }
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.onSignInClicked();
    }
  }

  onSignInClicked(e) {            
    
    this.props.doSignIn(this.loginID.value, this.password.value, this.site.value);
  }

  render() {
    return (
      <div>
        <Form horizontal >
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>
            </Col>
            <Col sm={10}>
              <strong>Sign in with your ESRF's user account</strong>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              Login
            </Col>
            <Col sm={8}>
              <FormControl type="text" placeholder="LoginID" autoFocus required inputRef={(ref) => { this.loginID = ref; }} />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>Password</Col>
            <Col sm={8}>
              <FormControl type="password" placeholder="Password" onKeyPress={this.handleKeyPress}
                inputRef={(ref) => { this.password = ref; }} />
            </Col>
          </FormGroup>


          {this.props.configuration && this.props.configuration.sites && this.props.configuration.sites.length > 0 &&
            <FormGroup>
              <Col componentClass={ControlLabel} sm={4}>Site</Col>
              <Col sm={8}>
                <FormGroup controlId="formControlsSelect">                  
                  <FormControl
                    inputRef={ el => this.site=el } 
                    componentClass="select" 
                    placeholder="Select site" 
                    style={{marginLeft:'14px'}}>
                    {this.props.configuration.sites.map((site, index) => (
                      <option value={site.name}>{site.displayName ? site.displayName : site.name}</option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>
            </FormGroup>
          }


        </Form>
        <div className="center-block text-center">
          <Button type="submit" loading={this.props.user.isAuthenticating} bsStyle="primary" onClick={this.onSignInClicked}>
            <Glyphicon glyph="glyphicon glyphicon-log-in" /> Log in
          </Button>
        </div>
        <div className="center-block text-center" style={{ marginTop: '10px' }}>
          <LoginAlertMessage error={this.props.user.error}></LoginAlertMessage>
        </div>
      </div>

    );
  }
}

class LoginAlertMessage extends React.Component {
  render() {
    if (!this.props.error) {
      return null;
    }
    return <Alert bsStyle="warning"><h4>{this.props.error}</h4></Alert>;
  }
};


LoginForm.propTypes = {
  username: PropTypes.string
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/Login/LoginForm.js